import library from '@/modules/library/library'

// Store functionality
import actions from '@/store/actions'
import getters from '@/store/getters'
import modules from '@/store/modules'
import mutations from '@/store/mutations'
import state from '@/store/state'
import { storePlugins } from '@/store/store-plugins'

/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */
// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// devtools true set before the new Vuex.Store allows the vue extension to inspect the state in Chrome.
Vue.config.devtools = process.env.VUE_APP_DEV_TOOLS === 'true'

modules[library.moduleName] = library

const store = new Vuex.Store({
  actions,
  getters,
  mutations,
  state,
  modules,
  plugins: [storePlugins],
})

export default store
